import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import i18n from './i18n'
import router from './router'

const app = createApp(App)

// 设置页面标题
function setPageTitle() {
  const locale = i18n.global.locale.value
  if (locale === 'zh') {
    document.title = '高毅咨询 - 专业企业管理咨询服务'
  } else {
    document.title = 'Gaoyi Consulting - Professional Management Consulting Services'
  }
}

// 初始设置
setPageTitle()

// 监听语言变化
import { watch } from 'vue'
watch(
  () => i18n.global.locale.value,
  () => {
    setPageTitle()
  }
)

app.use(router).use(i18n).mount('#app')
